import { Entity } from '../../domain/entity.js';
import { resolveMitigatedDamage } from '../../domain/combat/applyMitigatedDamage.js';
import {
  scheduleAramChampionRespawn,
  tickAramChampionRespawn,
  aramFountainPos
} from '../../domain/map/aramChampionRespawn.js';

/**
 * Smoke hooks for damage resist path + ARAM death→fountain respawn (FID-CBT-01).
 */
export function attachCombatDebugHooks(win) {
  if (!win) return;

  win.__debugTakeDamage = () => {
    const e = new Entity({
      id: 'dbg-dmg',
      type: 'champion',
      maxHp: 1000,
      armor: 100,
      mr: 100
    });
    e.hp = 1000;
    const phys = e.takeDamage(100, null, 'physical');
    const mag = e.takeDamage(100, null, 'magic');
    const raw = resolveMitigatedDamage(100, 'true', 100, 100);
    return {
      physicalEffective: phys.effectiveDamage,
      magicEffective: mag.effectiveDamage,
      trueRaw: raw,
      expectedResist: 50
    };
  };

  win.__debugAramRespawn = () => {
    const e = new Entity({
      id: 'dbg-respawn',
      type: 'champion',
      team: 'blue',
      x: 50,
      z: 50,
      maxHp: 400
    });
    e.hp = 0;
    e.isDead = true;
    scheduleAramChampionRespawn(e, 0.01);
    tickAramChampionRespawn(e, 0.01);
    const pad = aramFountainPos('blue');
    return {
      isDead: e.isDead,
      hp: e.hp,
      atFountain: e.x === pad.x && e.z === pad.z,
      padZ: pad.z
    };
  };
}
